import React from "react";

import { type InstallationScriptDetails } from "@north-beam/nb-common";
import { Video } from "@shared/video";

import { TrackingScriptCard } from "./tracking-script-card";

interface TrackingScriptTagsProps {
  installationScripts: InstallationScriptDetails;
  startExpanded?: boolean;
}
export const ShopifyOrderStatusTag = ({
  installationScripts,
  startExpanded,
}: TrackingScriptTagsProps): React.ReactElement => {
  return (
    <>
      <TrackingScriptCard
        displayName="Shopify: Northbeam Base Pixel Metadata Script"
        header={
          "If you use Shopify " +
          "please follow the instructions below to add an additional Northbeam script above where your Base Northbeam Pixel is located."
        }
        scriptCode={installationScripts.shopify_metadata_script}
        startExpanded={startExpanded}
        descriptionHTML={
          <>
            <p>
              <b>Installation instructions</b>
            </p>
            <p>
              Install this additional script on top of the Northbeam Base Pixel.
            </p>
            <img
              src="https://storage.googleapis.com/static.northbeam.io/images/shopify-metadata-script.png"
              className="img-fluid p-3"
              alt="shopify-metadata-script"
            />
          </>
        }
      />
      <TrackingScriptCard
        displayName="Shopify: Customer Events"
        header={
          "If you use Shopify and are on Shopify's Checkout Extensibility Flow, " +
          "please follow the instructions below to add Northbeam scripts to Shopify's Customer events."
        }
        scriptCode={installationScripts.customer_events_pixel}
        startExpanded={startExpanded}
        descriptionHTML={
          <>
            <p>
              <b>Installation instructions</b>
            </p>
            <p>
              In order for us to help support Shopify's Checkout Extensibility,
              it is required that you add in this Custom Pixel Script in the
              "Customer Events" setting within Shopify.
            </p>
            <p>
              Reference these video instructions as a guide to adding your pixel
              script in:
            </p>
            <p>
              NOTE: It is important to remember to still add in the Base
              Northbeam Pixel onto your Shopify either through your theme.liquid
              file or Google Tag Manager.
            </p>
            <Video
              title="Customer Events Pixel"
              src="https://www.loom.com/embed/19bb8e74bae442fab6a72ccc11a01add?sid=c30fe35f-2d2f-43a6-b3d6-fb29a7bb18cf"
            />
          </>
        }
      />
    </>
  );
};
